import React from 'react'
import Link from 'gatsby-link'
import {
  Dropdown,
  Menu,
  Grid,
  Button,
  Header,
  Container,
  Responsive,
  Icon,
} from 'semantic-ui-react'

const Navmenu = ({ siteTitle }) => (
  <div>
    <Responsive maxWidth={769}>
      <Menu
        secondary
        // fixed="top"
        borderless
        style={{
          paddingTop: '5px',
          //  paddingBottom: '5px',
          color: '#3a7bd5',
        }}
      >
        <Container style={{ maxWidth: '700px' }}>
          {/* <Menu.Item/> */}
          <Menu.Item as="a" href="/">
            <Header
              style={{
                // fontFamily: 'OpenSans-ExtraBold',
                fontFamily: 'Open Sans',
                fontWeight: '800',
                // fontSize: '140px',
                fontSize: '30px',
                color: 'white',
                letterSpacing: '-1.5px',
              }}
            >
              {' '}
              FindGrowthTools 🚀
            </Header>
          </Menu.Item>

          <Menu.Menu position="right">
            <Dropdown text="Menu" item pointing style={{ color: '#dcddde' }}>
              <Dropdown.Menu>
                <Dropdown.Item href="/search/">Search</Dropdown.Item>{' '}
                <Dropdown.Divider />
                <Dropdown.Header>Find by</Dropdown.Header>
                <Dropdown.Item href="/categories/">Category</Dropdown.Item>{' '}
                <Dropdown.Item href="/growthlevers/">
                  Growth Lever
                </Dropdown.Item>{' '}
                <Dropdown.Item href="/integrations/">Integration</Dropdown.Item>{' '}
                <Dropdown.Item href="/customers/">Customer</Dropdown.Item>{' '}
                <Dropdown.Divider />
                <Dropdown.Item href="/about/">About</Dropdown.Item>
                <Dropdown.Item href="/suggest/">Suggest a tool</Dropdown.Item>
                <Dropdown.Item href="/contact/">Contact</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <Menu.Item />
            <Menu.Item />
            {/* <Menu.Item>
            <Button primary>Sign Up</Button>
          </Menu.Item> */}
          </Menu.Menu>
        </Container>
      </Menu>
    </Responsive>

    {/* LARGER SCREENS */}
    <Responsive minWidth={770}>
      <Menu
        secondary
        // fixed="top"
        borderless
        style={{
          paddingTop: '5px',
          //  paddingBottom: '5px',
          color: '#3a7bd5',
        }}
      >
        <Container style={{ maxWidth: '700px' }}>
          {/* <Menu.Item/> */}
          <Menu.Item as="a" href="/">
            <Header
              style={{
                // fontFamily: 'OpenSans-ExtraBold',
                fontFamily: 'Open Sans',
                fontWeight: '800',
                // fontSize: '140px',
                fontSize: '30px',
                color: 'white',
                letterSpacing: '-1.5px',
              }}
            >
              {' '}
              Find<span style={{ fontWeight: '900' }}>GrowthTools</span> 🚀
            </Header>
          </Menu.Item>

          <Menu.Menu position="right">
            <Menu.Item style={{ color: '#dcddde' }} href="/search/">
              <Icon name="search" />Search
            </Menu.Item>
            <Dropdown
              text="Find Tools"
              item
              pointing
              style={{ color: '#dcddde' }}
            >
              <Dropdown.Menu>
                <Dropdown.Header>Find by</Dropdown.Header>
                <Dropdown.Item href="/categories/">Category</Dropdown.Item>{' '}
                <Dropdown.Item href="/growthlevers/">
                  Growth Lever
                </Dropdown.Item>{' '}
                <Dropdown.Item href="/integrations/">Integration</Dropdown.Item>{' '}
                <Dropdown.Item href="/customers/">Customer</Dropdown.Item>{' '}
              </Dropdown.Menu>
            </Dropdown>

            <Menu.Item
              position="right"
              style={{ color: '#dcddde' }}
              href="/about/"
            >
              About
            </Menu.Item>
            <Menu.Item style={{ color: '#dcddde' }} href="/suggest/">
              Suggest a tool
            </Menu.Item>

            <Menu.Item />
            {/* <Menu.Item>
            <Button primary>Sign Up</Button>
          </Menu.Item> */}
          </Menu.Menu>
        </Container>
      </Menu>
      {/* <div style={{textAlign: 'center'}}><Header as="a" href="/" style={{
      fontFamily: 'OpenSans-ExtraBold',
      // fontSize: '140px',
      fontSize: '75px',
      color: 'white',
      letterSpacing: '-5.5px',
      textAlign: 'center'
      
      
      }}>FindGrowthTools</Header></div> */}
    </Responsive>
  </div>
)

export default Navmenu



// WEBPACK FOOTER //
// ./src/components/navmenu.js